export { default } from "./Client";



// WEBPACK FOOTER //
// ./src/components/emission/client-summary/Client/index.js